import { render } from "./FuncionalidadesTramite.vue?vue&type=template&id=c438c432&scoped=true"
import script from "./FuncionalidadesTramite.vue?vue&type=script&lang=js"
export * from "./FuncionalidadesTramite.vue?vue&type=script&lang=js"

import "./FuncionalidadesTramite.vue?vue&type=style&index=0&id=c438c432&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c438c432"]])

export default __exports__